<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            persistent
            :width="items.length ? '750' : '500'">
            <v-card>
                <v-card-title>
                    {{ $t('search_item_title') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="search"
                        ref="searchField" 
                        @keypress.enter="searchItem"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.itemSearch"
                        :label="$t('search')">
                    </v-text-field>
                    <v-data-table
                        v-if="items.length"
                        dense
                        hide-default-footer
                        :items="items"
                        disable-pagination
                        :height="items.length ? '300' : '100'"
                        v-model="selected.itemSearch"
                        :headers="headers.itemSearch"
                        show-select
                        single-select>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn 
                        v-if="items.length"
                        :disabled="!selected.itemSearch.length"  
                        @click="submit" 
                        text>
                        {{ $t('btn_select') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    name: "ItemSearchDialog",
    components: {
        
    },
    data() {
        return {
            display: false,
            search: null,
            loading: {
                itemSearch: false,
                search: false,
                data: false
            },
            headers: {
                itemSearch: [
                    { text: this.$t('code'), value: "code" },
                    { text: this.$t('description'), value: "name" },
                    { text: this.$t('unit_measure'), value: "base_unit_of_measure.name" },
                    { text: this.$t('type'), value: "item_type" }
                ]
            },
            selected: {
                itemSearch: []
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            },  
        }
    },
    computed: {
        ...mapState('warehouse/item', ["items"]) 
    },
    methods: {
        ...mapActions('warehouse/item', ["fetchItems", "restItems"]),
        open(params){
            this.search = params;
            this.restItems();
            this.display = true;
            this.searchItem();
        },
        setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
       async searchItem() {
            if(this.search) {
                this.restItems();
                this.clearError();
                this.loading.itemSearch = true;
                try {
                    await this.fetchItems({ search: this.search });
                    this.loading.itemSearch = false;
                    if(!this.items.length) this.setError(this.$t('no_result'));
                    if(this.items.length == 1) this.submit();
                } catch(error) {
                    this.loading.itemSearch = false;
                    let message = error.response ? error.response.data.message : error; 
                    this.setError(message);
                }
            } else {
                this.setError(this.$t('rules_required'))
            }
       },

       submit() {
            if(this.items.length == 1) this.$emit('store', this.items[0]);
            else this.$emit('store', this.selected.itemSearch[0]);
            this.close();
       },
        close() {
            this.display = false;
            this.search = null;
            this.selected.itemSearch = [];
            this.restItems();
        }
        
    }
}
</script>